import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { useSelector } from 'react-redux';
import axios from 'axios';

function ZipCodes() {
    const user = useSelector(state => state.user);
    const [garagesList, setGaragesList] = useState({});
    const [refreshKey, setRefreshKey] = useState(0);
    useEffect(() => {
        axios.post(`${process.env.REACT_APP_API_URL}?action=getPrice`)
            .then(response => {
                setGaragesList(response.data.data);
                console.log(response.data)
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }, [refreshKey])

    function EditZipcode() {
        Swal.fire({
            title: 'Change per Zipcode Price?',
            showCancelButton: true,
            closeOnConfirm: false,
            animation: "slide-from-top",
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Change it!',
            input: 'text',
            inputPlaceholder: garagesList.price ?? "Zipcode Price"
        }).then(async (result) => {
            if (result.isConfirmed) {
                const inputValue = parseFloat(result.value);
                if (inputValue === "") {
                    Swal.fire("You need to add price!");
                } else if (isNaN(inputValue)) {
                    Swal.fire("You need to add correct value for price!");
                } else {
                    const parameters = {
                        action: 'UpdateZipcodePrice',
                        updatetype: 'price',
                        price: inputValue,
                        ownerID: user.uid
                    }
                    axios.post(`${process.env.REACT_APP_API_URL}`, parameters)
                        .then(response => {
                            setRefreshKey(oldKey => oldKey + 1)
                            console.log(response.data)
                            Swal.fire(
                                'Zipcode Updated',
                                'your zipcode is updated',
                                'success'
                            )
                        })
                        .catch(error => {
                            Swal.fire(
                                'There were a problem',
                                error ? error : 'Please, try again or contact SAGE Parents ',
                                'error',
                            )
                        });
                }
            }
        });
    }

    function EditDiscount() {
        Swal.fire({
            title: 'Change Yearly Discount?',
            showCancelButton: true,
            closeOnConfirm: false,
            animation: "slide-from-top",
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Change it!',
            input: 'text',
            inputPlaceholder: garagesList.yearlyDiscount ?? "Yearly Discount in %",
        }).then(async (result) => {
            if (result.isConfirmed) {
                const inputValue = parseFloat(result.value);
                if (inputValue === "") {
                    Swal.fire("You need to add discount!");
                } else if (isNaN(inputValue)) {
                    Swal.fire("You need to add correct value for discount!");
                } else {
                    const parameters = {
                        action: 'UpdateZipcodePrice',
                        updatetype: 'discount',
                        yearlyDiscount: inputValue,
                        ownerID: user.uid
                    }
                    axios.post(`${process.env.REACT_APP_API_URL}`, parameters)
                        .then(response => {
                            setRefreshKey(oldKey => oldKey + 1)
                            console.log(response.data)
                            if (response.data.status === true) {
                                Swal.fire(
                                    'Yearly Discount Updated',
                                    'your yearly discount is updated',
                                    'success'
                                )
                            } else {
                                Swal.fire(
                                    'Yearly Discount Not Updated',
                                    response.data.message,
                                    'error'
                                )
                            }
                        })
                        .catch(error => {
                            Swal.fire(
                                'There were a problem',
                                error ? error : 'Please, try again or contact SAGE Parents ',
                                'error',
                            )
                        });
                }
            }
        });
    }

    function EditGarageCutoffDiscount() {
        Swal.fire({
            title: 'Change Service Fee?',
            showCancelButton: true,
            closeOnConfirm: false,
            animation: "slide-from-top",
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Change it!',
            input: 'text',
            inputPlaceholder: garagesList.garage_cutoff ?? "Per Payment",
        }).then(async (result) => {
            if (result.isConfirmed) {
                const inputValue = parseFloat(result.value);
                if (inputValue === "") {
                    Swal.fire("You need to add Service Fee!");
                } else if (isNaN(inputValue)) {
                    Swal.fire("You need to add correct value for Service Fee!");
                } else {
                    const parameters = {
                        action: 'UpdateZipcodePrice',
                        updatetype: 'garage_cutoff',
                        garage_cutoff: inputValue,
                        ownerID: user.uid
                    }
                    axios.post(`${process.env.REACT_APP_API_URL}`, parameters)
                        .then(response => {
                            setRefreshKey(oldKey => oldKey + 1)
                            console.log(response.data)
                            if (response.data.status === true) {
                                Swal.fire(
                                    'Service Fee Updated',
                                    'your Service Fee is updated',
                                    'success'
                                )
                            } else {
                                Swal.fire(
                                    'Service Fee Not Updated',
                                    response.data.message,
                                    'error'
                                )
                            }

                        })
                        .catch(error => {
                            Swal.fire(
                                'There were a problem',
                                error ? error : 'Please, try again or contact SAGE Parents ',
                                'error',
                            )
                        });
                }
            }
        });
    }


    return (
        <section className="page-content sec-padding">
            <div className="container-fluid">
                <div className="page-content-details">
                    <div className='row'>
                        <div className="card col-md-6 mx-auto">
                            <div className="card-body">
                                <h5 className="card-title">Zipcodes</h5>
                                <p className="card-text">Current Zipcode price is {garagesList.price}</p>
                                <button className='btn btn-primary add_garage' onClick={EditZipcode}>Edit ZipCodes</button>
                            </div>
                        </div>
                    </div>


                    <div className='row'>
                        <div className="card col-md-6 mx-auto mt-4">
                            <div className="card-body">
                                <h5 className="card-title">Yearly Discount</h5>
                                <p className="card-text">Yearly Discount on all Zipcodes is {garagesList.yearlyDiscount}%</p>
                                <button className='btn btn-primary add_garage' onClick={EditDiscount}>Edit Discount</button>
                            </div>
                        </div>

                    </div>
                    <div className='row'>
                        <div className="card col-md-6 mx-auto mt-4">
                            <div className="card-body">
                                <h5 className="card-title">Service Fee</h5>
                                <p className="card-text">Per Payment {garagesList.garage_cutoff}%</p>
                                <button className='btn btn-primary add_garage' onClick={EditGarageCutoffDiscount}>Edit Service Fee</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
}

export default ZipCodes;